// eslint-disable-next-line local-eslint-rules/no-direct-api-hook-access
import { useDashboardApiMutation } from "@services/useDashboardApi";

import { ErrorCode } from "./errorCodes";

export const useVerifyEmail = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (errorCode: ErrorCode) => void;
}) => {
  return useDashboardApiMutation("POST", "/free_trial/verify_email", {
    options: {
      onSuccess,
      onError: (err) => {
        const errorCode: ErrorCode = err?.responseJson?.error.code ?? ErrorCode.Unknown;
        onError(errorCode);
      },
    },
    disableDefaultErrorToast: true,
  });
};
